var map = {
	"./Lottery.js": "f142",
	"./Lotto.js": "d6e8",
	"./allstatement.js": "f40e",
	"./auth.js": "446a",
	"./betting.js": "b041",
	"./dashboard.js": "986a",
	"./dashboardLive.js": "2c1a",
	"./deposit.js": "f324",
	"./index.js": "b2c6",
	"./klaklouk.js": "5240",
	"./myInfo.js": "c55a",
	"./result.js": "9d56",
	"./tigerDragon.js": "6743",
	"./withdraw.js": "b8cc",
	"./yuki.js": "f51a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ced4";